import React from 'react';
import styled from 'styled-components';
import Wrapper from '../Wrapper';
import { HotelImageHolder } from '../../utils/statics';
import Image from './Image';

const ImageWrapper = styled(Wrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImageHolder = styled(Image)`
  max-width: 75%;
  min-height: 135px;
  max-height: 72%;
`;

const HotelGenericImage = props => (
  <ImageWrapper
    width="100%"
    height="100%"
    backgroundColor="greyLighter"
    {...props}
  >
    <ImageHolder src={HotelImageHolder} objectFit="contain" />
  </ImageWrapper>
);

export default HotelGenericImage;
